import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const BottomTabBar: React.FC = () => {
  const location = useLocation();
  const [safeAreaLoaded, setSafeAreaLoaded] = useState(false);

  // Add useEffect to inject the viewport meta tag with viewport-fit=cover
  useEffect(() => {
    // Check if the meta tag already exists
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    const originalContent = viewportMeta?.getAttribute('content') || '';
    
    // Only update if 'viewport-fit=cover' is not already included
    if (viewportMeta && !originalContent.includes('viewport-fit=cover')) {
      viewportMeta.setAttribute('content', `${originalContent}, viewport-fit=cover`);
    } else if (!viewportMeta) {
      // Create a new viewport meta tag if it doesn't exist
      viewportMeta = document.createElement('meta');
      viewportMeta.setAttribute('name', 'viewport');
      viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1, viewport-fit=cover');
      document.head.appendChild(viewportMeta);
    }

    // Set a flag to indicate safe area support is loaded
    setSafeAreaLoaded(true);

    // Cleanup function
    return () => {
      // Optionally restore the original viewport meta if needed
      if (viewportMeta) {
        viewportMeta.setAttribute('content', originalContent);
      }
    };
  }, []);

  const isActive = (path: string) => {
    return location.pathname === path ? 'text-primary' : 'text-gray-500';
  };

  return (
    <div className={`
      md:hidden 
      fixed 
      bottom-0 
      left-0 
      right-0 
      bg-white 
      border-t 
      border-gray-200 
      z-30
      pb-safe
    `}
    >
      <div className="grid grid-cols-5 h-16">
        <Link
          to="/"
          className={`flex flex-col items-center justify-center ${isActive('/')}`}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          <span className="text-xs mt-1">Home</span>
        </Link>
        
        <Link
          to="/schedule"
          className={`flex flex-col items-center justify-center ${isActive('/schedule')}`}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span className="text-xs mt-1">Calendar</span>
        </Link>
        
        <Link
          to="/checkin"
          className={`flex flex-col items-center justify-center ${isActive('/checkin')}`}
        >
          <div className="relative">
            <div className="absolute inset-0 bg-primary rounded-full transform scale-110"></div>
            <div className="relative bg-white p-2 rounded-full border-4 border-primary">
              <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
          </div>
          <span className="text-xs mt-1 font-medium whitespace-nowrap">Attendance</span>
        </Link>
        
        <Link
          to="/leave"
          className={`flex flex-col items-center justify-center ${isActive('/leave')}`}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V5a4 4 0 018 0v2M6 7h12a2 2 0 012 2v9a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2z" />
          </svg>
          <span className="text-xs mt-1">Leave</span>
        </Link>
        
        <Link
          to="/profile"
          className={`flex flex-col items-center justify-center ${isActive('/profile')}`}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          <span className="text-xs mt-1">Profile</span>
        </Link>
      </div>
    </div>
  );
};

export default BottomTabBar; 